<template>
  <div id="wrapper">
    <component-sidebar :force-mini="true"/>
    <div id="page-wrapper">
      <div class="row" style="background: #293846;">
        <sub-menu v-if="command" :command="command"/>
        <div class="col-lg-10 animated fadeInRight gray-bg"
             style="min-height: 100vh;">
          <component-header :hide-expand-button="true"/>
          <div class="row wrapper border-bottom white-bg page-heading">
            <div class="col-lg-12 white-bg">
              <h2>{{ $route.meta.name }}</h2>
              <ol class="breadcrumb">
                <li>
                  <router-link to="/">Accueil</router-link>
                </li>
                <li>
                  <router-link to="/">Liste des commandes</router-link>
                </li>
                <li>
                  <a>Commande #{{ commandId }}</a>
                </li>
                <li class="active">
                  <strong>{{ $route.meta.name }}</strong>
                </li>
              </ol>
            </div>
          </div>
          <div class="wrapper-content">
            <spinner-three-bounce :displayNone="!$apollo.queries.order.loading"/>

            <general-infos v-if="command"
                           :command="command"
                           :canEditVehicle="false"
                           :price="command.buyerPrice"
                           :vehicle="vehicle"
                           :seller="seller"
                           :buyer="buyer"/>
            <component v-if="command"
                       :is="$route.name"
                       :command="command"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import Header from '../components/Header.vue'
  import Sidebar from '../components/Sidebar.vue'
  import Submenu from '../components/Submenu.vue'
  import GeneralInfos from '../components/details/GeneralInfos'
  import Recapitulatif from '../pages/CommandDetails/Recapitulatif'
  import ProprietaireActuel from '../pages/CommandDetails/ProprietaireActuel'
  import FuturProprietaire from '../pages/CommandDetails/FuturProprietaire'
  import RdvCession from '../pages/CommandDetails/RdvCession'
  import DeliveryLight from '../pages/CommandDetails/DeliveryLight'
  import Documents from '../pages/CommandDetails/Documents'
  import Virement from '../pages/CommandDetails/Virement'
  import VirementB from '../pages/CommandDetails/VirementB'
  import VirementLemonway from '../pages/CommandDetails/VirementLemonway'
  import VirementLemonwayB from '../pages/CommandDetails/VirementLemonwayB'
  import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'

  export default {
    components: {
      GeneralInfos,
      'component-header': Header,
      'component-sidebar': Sidebar,
      'sub-menu': Submenu,
      'command-details-recapitulatif': Recapitulatif,
      'command-details-recapitulatif-success': Recapitulatif,
      'command-details-recapitulatif-error': Recapitulatif,
      'command-details-recapitulatif-cancel': Recapitulatif,
      'command-details-proprietaire-actuel': ProprietaireActuel,
      'command-details-futur-proprietaire': FuturProprietaire,
      'command-details-cession': RdvCession,
      'command-details-delivery-light': DeliveryLight,
      'command-details-documents': Documents,
      'command-details-virement-lemonway': VirementLemonway,
      'command-details-virement-lemonway-b': VirementLemonwayB,
      'command-details-lemonway': Virement,
      'command-details-lemonway-b': VirementB,
      'command-details-credit': Virement,
      SpinnerThreeBounce
    },

    data: () => ({
      order: null
    }),

    computed: {
      commandDetailQuery () {
        return gql`
          { order (id: "${this.commandId}") {
            id
            creationDate
            realm
            adId
            ad {
              id
              supplier
            }
            appraisal {
              id
            }
            status {
              id
              label
            }
            delivery
            buyerPrice
            paymentMode
            saleCommission
            commercial {
              id
              firstname
              lastname
            }
            options {
              id
              name
              type
              isWarrantyOption
            }
            seller {
              id
              firstname
              lastname
              email
              phone
              wallet {
                url
                lemonwayId
              }
              address {
                address
                city
                zipCode
              }
              civility
              birthDate
            }
            buyer {
              id
              firstname
              lastname
              email
              phone
              usedName
              birthPlace
              wallet {
                url
                lemonwayId
              }
              address {
                address
                city
                zipCode
              }
              civility
              birthDate
            }
            vehicule {
              id
              make
              model
              version
              color
              fuel
              licensePlate
              city
              department
              kilometers
              gearType
              releaseDate
              year
              body
              doorsNumber
              photo
              url
              vehicleIdentification
              appraisalExpert {
                id
                name
              }
              appraisalDate
              over4years
              consVisit
              registrationDate
              typeVariantVersion
              minesType
              denomCommercial
              vehicleIdentification
              nationalGender
              rateCO2
              formulaNumber
              cylindersNumber
              taxHorsePower
              typeOfVehicle
              infoCG {
                lastNameOwner
                lastNameCoOwner
                firstNameOwner
                firstNameCoOwner
                address {
                  address
                  city
                  zipCode
                }
              }
            }
            saleRdv {
              id
              address {
                address
                zipCode
                city
             }
              status
              date
              comment
              expertiseComment
            }
            saleRdvExpert {
              id,
              name,
              phonenumber,
              type
              address {
                address
                zipCode
                city
             }
            }
            promoCode {
              name
              value
            }
            pageInfo {
              totalPages
            }
            department
            region
            zip
          }
          }
        `
      },

      hasResult () {
        return this.order && this.order.length
      },

      vehicle () {
        return this.hasResult ? this.order[0].vehicule[0] : null
      },

      seller () {
        return this.hasResult ? this.order[0].seller[0] : null
      },

      buyer () {
        return this.hasResult ? this.order[0].buyer[0] : null
      },

      commandId () {
        return this.$route.params.id
      },

      command () {
        return this.hasResult ? this.order[0] : null
      }
    },

    mounted () {
      $(document).trigger('vue-loaded')
    },

    apollo: {
      order: {
        query () {
          return this.commandDetailQuery
        },
      },
    }
  }
</script>
